import { useQueries, UseQueryResult } from '@tanstack/react-query'
import { logError } from 'utils/logger'

import { CurrencyConversionRatesQuery } from './domain/ConversionRates'
import { useCurrencyConversionRatesDataLoader } from './useCurrencyConversionRatesDataLoader'

export const useCurrencyConversionRatesQuery = (
  queries: CurrencyConversionRatesQuery[]
): UseQueryResult<number, string | Error>[] => {
  const dataloader = useCurrencyConversionRatesDataLoader()

  const results = useQueries({
    queries: queries.map((query) => ({
      queryKey: [
        'conversionRates',
        `${query.currencyExchangeRateId}-${query.fromCurrencyCode}-${query.toCurrencyCode}`,
      ],

      queryFn: () => dataloader.load(query),
      onError: logError,
    })),
  })

  return results
}
